
import { AdministrativeTools } from '../../components/dashboard/administrative-tools/administrative-section';
import { DashboardHero } from '../../components/dashboard/dashboard-hero';
import { RecentActivity } from '../../components/dashboard/recent-activity';
import { ExploreDiscount } from '../../components/dashboard/explore-discount';
import { Features } from '../../components/new-home';
import DiscoverFeatures from '../../components/dashboard/discover-features/discover-features-section/component';
import { Banner } from '@components';
import { PRIMARY_BANNER_TYPE, SECONDARY_BANNER_TYPE } from '@share/common-types';

const Dashboard = () => {
  return (
    <>
      <DashboardHero />
      <AdministrativeTools />
      <RecentActivity />
      <Banner type={PRIMARY_BANNER_TYPE} />
      <ExploreDiscount />
      <Features withAction={true} />
      <DiscoverFeatures />
      <div className="pb-4">
        <Banner type={SECONDARY_BANNER_TYPE} />
      </div>
    </>
  );
};

export { Dashboard };
